<template>
    <div class="page bg-gray page-flex">
        <backTitleBar></backTitleBar>
        <div class="flex1 posi-rel">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <div v-for="(item,$index) in data" :key="$index" class="list-item click" @click="getScrollerPosition();$router.push({ name:'overDateDetail',query:{shopId:item.shopId,selectType:0}})">
                    <div class="flex-center">
                        <div class="flex1 fs-32 color-333 flex-center"><div class="label">RFID柜</div>{{item.shopName}} </div>

                        <div class="fs-32 color-org ml-20">待处理</div>
                    </div>
                    <div class="flex fs-28 mt-10">
                        <div class="color-999">数量：<span class="color-333">{{item.rfidCount}}</span></div>
                        <div class="color-999" style="margin-left: .5rem">种类：<span class="color-333">{{item.typeCount}}</span></div>
                    </div>
                </div>
            </scroller>
        </div>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "overDateWarning",
        mixins: [initData,routerBack],
        components:{backTitleBar},
        data(){
            return{

            }
        },
        methods:{
            beforeInit() {
                this.params = { page : this.page, limit: this.limit};
                this.url = 'item/shopItem/qryArmShopItem';
                return true
            },
        },
        beforeRouteEnter(to, from, next) {
            if (from.name == "overDateDetail") {
                to.meta.isBack = true;
            } else {
                to.meta.isBack = false;
            }
            next();
        },
        activated() {
            if (!this.$route.meta.isBack) {
                if(this.hasAlive){
                    this.handleQuery();
                }
            }
            this.$route.meta.isBack = false;
        },
    }
</script>

<style scoped lang="scss">
    .list-item{
        margin: .2rem .24rem;
        background: #fff;
        border-radius: .12rem;
        overflow: hidden;
        padding: .2rem .24rem .2rem .34rem;
        border-left: .06rem solid $org;
        .label{
            padding: 0 .1rem;
            height: .4rem;
            line-height: .4rem;
            margin-right: .1rem;
            background: $main-color;
            color: #fff;
            font-size: .24rem;
            font-weight: normal;
            border-radius: .06rem;
        }
    }
</style>



// WEBPACK FOOTER //
// overDateWarning.vue?1ac71bc0